module.exports = __webpack_public_path__ + "static/media/Icn-bin.50d021a0.svg";